import _defineProperty from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { TableColumn } from "./TableColumn";
import { TableIndex } from "./TableIndex";
import { TableForeignKey } from "./TableForeignKey";
import { TableUtils } from "../util/TableUtils";
import { TableUnique } from "./TableUnique";
import { TableCheck } from "./TableCheck";
import { TableExclusion } from "./TableExclusion";
/**
 * Table in the database represented in this class.
 */
export var Table = /*#__PURE__*/function () {
  // -------------------------------------------------------------------------
  // Constructor
  // -------------------------------------------------------------------------
  function Table(options) {
    _classCallCheck(this, Table);
    this["@instanceof"] = Symbol.for("Table");
    /**
     * Table columns.
     */
    this.columns = [];
    /**
     * Table indices.
     */
    this.indices = [];
    /**
     * Table foreign keys.
     */
    this.foreignKeys = [];
    /**
     * Table unique constraints.
     */
    this.uniques = [];
    /**
     * Table check constraints.
     */
    this.checks = [];
    /**
     * Table exclusion constraints.
     */
    this.exclusions = [];
    /**
     * Indicates if table was just created.
     * This is needed, for example to check if we need to skip primary keys creation
     * for new tables.
     */
    this.justCreated = false;
    /**
     * Enables Sqlite "WITHOUT ROWID" modifier for the "CREATE TABLE" statement
     */
    this.withoutRowid = false;
    if (options) {
      this.database = options.database;
      this.schema = options.schema;
      this.name = options.name;
      if (options.columns) this.columns = options.columns.map(function (column) {
        return new TableColumn(column);
      });
      if (options.indices) this.indices = options.indices.map(function (index) {
        return new TableIndex(index);
      });
      if (options.foreignKeys) this.foreignKeys = options.foreignKeys.map(function (foreignKey) {
        return new TableForeignKey(_objectSpread(_objectSpread({}, foreignKey), {}, {
          referencedDatabase: (foreignKey === null || foreignKey === void 0 ? void 0 : foreignKey.referencedDatabase) || options.database,
          referencedSchema: (foreignKey === null || foreignKey === void 0 ? void 0 : foreignKey.referencedSchema) || options.schema
        }));
      });
      if (options.uniques) this.uniques = options.uniques.map(function (unique) {
        return new TableUnique(unique);
      });
      if (options.checks) this.checks = options.checks.map(function (check) {
        return new TableCheck(check);
      });
      if (options.exclusions) this.exclusions = options.exclusions.map(function (exclusion) {
        return new TableExclusion(exclusion);
      });
      if (options.justCreated !== undefined) this.justCreated = options.justCreated;
      if (options.withoutRowid) this.withoutRowid = options.withoutRowid;
      this.engine = options.engine;
    }
  }
  // -------------------------------------------------------------------------
  // Accessors
  // -------------------------------------------------------------------------
  _createClass(Table, [{
    key: "primaryColumns",
    get: function get() {
      return this.columns.filter(function (column) {
        return column.isPrimary;
      });
    }
    // -------------------------------------------------------------------------
    // Public Methods
    // -------------------------------------------------------------------------
    /**
     * Clones this table to a new table with all properties cloned.
     */
  }, {
    key: "clone",
    value: function clone() {
      return new Table({
        schema: this.schema,
        database: this.database,
        name: this.name,
        columns: this.columns.map(function (column) {
          return column.clone();
        }),
        indices: this.indices.map(function (constraint) {
          return constraint.clone();
        }),
        foreignKeys: this.foreignKeys.map(function (constraint) {
          return constraint.clone();
        }),
        uniques: this.uniques.map(function (constraint) {
          return constraint.clone();
        }),
        checks: this.checks.map(function (constraint) {
          return constraint.clone();
        }),
        exclusions: this.exclusions.map(function (constraint) {
          return constraint.clone();
        }),
        justCreated: this.justCreated,
        withoutRowid: this.withoutRowid,
        engine: this.engine
      });
    }
    /**
     * Add column and creates its constraints.
     */
  }, {
    key: "addColumn",
    value: function addColumn(column) {
      this.columns.push(column);
    }
    /**
     * Remove column and its constraints.
     */
  }, {
    key: "removeColumn",
    value: function removeColumn(column) {
      var foundColumn = this.columns.find(function (c) {
        return c.name === column.name;
      });
      if (foundColumn) this.columns.splice(this.columns.indexOf(foundColumn), 1);
    }
    /**
     * Adds unique constraint.
     */
  }, {
    key: "addUniqueConstraint",
    value: function addUniqueConstraint(uniqueConstraint) {
      this.uniques.push(uniqueConstraint);
      if (uniqueConstraint.columnNames.length === 1) {
        var uniqueColumn = this.columns.find(function (column) {
          return column.name === uniqueConstraint.columnNames[0];
        });
        if (uniqueColumn) uniqueColumn.isUnique = true;
      }
    }
    /**
     * Removes unique constraint.
     */
  }, {
    key: "removeUniqueConstraint",
    value: function removeUniqueConstraint(removedUnique) {
      var foundUnique = this.uniques.find(function (unique) {
        return unique.name === removedUnique.name;
      });
      if (foundUnique) {
        this.uniques.splice(this.uniques.indexOf(foundUnique), 1);
        if (foundUnique.columnNames.length === 1) {
          var uniqueColumn = this.columns.find(function (column) {
            return column.name === foundUnique.columnNames[0];
          });
          if (uniqueColumn) uniqueColumn.isUnique = false;
        }
      }
    }
    /**
     * Adds check constraint.
     */
  }, {
    key: "addCheckConstraint",
    value: function addCheckConstraint(checkConstraint) {
      this.checks.push(checkConstraint);
    }
    /**
     * Removes check constraint.
     */
  }, {
    key: "removeCheckConstraint",
    value: function removeCheckConstraint(removedCheck) {
      var foundCheck = this.checks.find(function (check) {
        return check.name === removedCheck.name;
      });
      if (foundCheck) {
        this.checks.splice(this.checks.indexOf(foundCheck), 1);
      }
    }
    /**
     * Adds exclusion constraint.
     */
  }, {
    key: "addExclusionConstraint",
    value: function addExclusionConstraint(exclusionConstraint) {
      this.exclusions.push(exclusionConstraint);
    }
    /**
     * Removes exclusion constraint.
     */
  }, {
    key: "removeExclusionConstraint",
    value: function removeExclusionConstraint(removedExclusion) {
      var foundExclusion = this.exclusions.find(function (exclusion) {
        return exclusion.name === removedExclusion.name;
      });
      if (foundExclusion) {
        this.exclusions.splice(this.exclusions.indexOf(foundExclusion), 1);
      }
    }
    /**
     * Adds foreign keys.
     */
  }, {
    key: "addForeignKey",
    value: function addForeignKey(foreignKey) {
      this.foreignKeys.push(foreignKey);
    }
    /**
     * Removes foreign key.
     */
  }, {
    key: "removeForeignKey",
    value: function removeForeignKey(removedForeignKey) {
      var fk = this.foreignKeys.find(function (foreignKey) {
        return foreignKey.name === removedForeignKey.name;
      });
      if (fk) this.foreignKeys.splice(this.foreignKeys.indexOf(fk), 1);
    }
    /**
     * Adds index.
     */
  }, {
    key: "addIndex",
    value: function addIndex(index) {
      var isMysql = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.indices.push(index);
      // in Mysql unique indices and unique constraints are the same thing
      // if index is unique and have only one column, we mark this column as unique
      if (index.columnNames.length === 1 && index.isUnique && isMysql) {
        var column = this.columns.find(function (c) {
          return c.name === index.columnNames[0];
        });
        if (column) column.isUnique = true;
      }
    }
    /**
     * Removes index.
     */
  }, {
    key: "removeIndex",
    value: function removeIndex(tableIndex) {
      var isMysql = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var index = this.indices.find(function (index) {
        return index.name === tableIndex.name;
      });
      if (index) {
        this.indices.splice(this.indices.indexOf(index), 1);
        // in Mysql unique indices and unique constraints are the same thing
        // if index is unique and have only one column, we move `unique` attribute from its column
        if (index.columnNames.length === 1 && index.isUnique && isMysql) {
          var column = this.columns.find(function (c) {
            return c.name === index.columnNames[0];
          });
          if (column) column.isUnique = this.indices.some(function (ind) {
            return ind.columnNames.length === 1 && ind.columnNames[0] === column.name && !!index.isUnique;
          });
        }
      }
    }
  }, {
    key: "findColumnByName",
    value: function findColumnByName(name) {
      return this.columns.find(function (column) {
        return column.name === name;
      });
    }
    /**
     * Returns all column indices.
     */
  }, {
    key: "findColumnIndices",
    value: function findColumnIndices(column) {
      return this.indices.filter(function (index) {
        return !!index.columnNames.find(function (columnName) {
          return columnName === column.name;
        });
      });
    }
    /**
     * Returns all column foreign keys.
     */
  }, {
    key: "findColumnForeignKeys",
    value: function findColumnForeignKeys(column) {
      return this.foreignKeys.filter(function (foreignKey) {
        return !!foreignKey.columnNames.find(function (columnName) {
          return columnName === column.name;
        });
      });
    }
    /**
     * Returns all column uniques.
     */
  }, {
    key: "findColumnUniques",
    value: function findColumnUniques(column) {
      return this.uniques.filter(function (unique) {
        return !!unique.columnNames.find(function (columnName) {
          return columnName === column.name;
        });
      });
    }
    /**
     * Returns all column checks.
     */
  }, {
    key: "findColumnChecks",
    value: function findColumnChecks(column) {
      return this.checks.filter(function (check) {
        return !!check.columnNames.find(function (columnName) {
          return columnName === column.name;
        });
      });
    }
    // -------------------------------------------------------------------------
    // Static Methods
    // -------------------------------------------------------------------------
    /**
     * Creates table from a given entity metadata.
     */
  }], [{
    key: "create",
    value: function create(entityMetadata, driver) {
      var database = entityMetadata.database === driver.database ? undefined : entityMetadata.database;
      var schema = entityMetadata.schema === driver.options.schema ? undefined : entityMetadata.schema;
      var options = {
        database: entityMetadata.database,
        schema: entityMetadata.schema,
        name: driver.buildTableName(entityMetadata.tableName, schema, database),
        withoutRowid: entityMetadata.withoutRowid,
        engine: entityMetadata.engine,
        columns: entityMetadata.columns.filter(function (column) {
          return column && !column.isVirtualProperty;
        }).map(function (column) {
          return TableUtils.createTableColumnOptions(column, driver);
        }),
        indices: entityMetadata.indices.filter(function (index) {
          return index.synchronize === true;
        }).map(function (index) {
          return TableIndex.create(index);
        }),
        uniques: entityMetadata.uniques.map(function (unique) {
          return TableUnique.create(unique);
        }),
        checks: entityMetadata.checks.map(function (check) {
          return TableCheck.create(check);
        }),
        exclusions: entityMetadata.exclusions.map(function (exclusion) {
          return TableExclusion.create(exclusion);
        })
      };
      return new Table(options);
    }
  }]);
  return Table;
}();